import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import { baseUrl } from '../../../config';
import DatePicker from "react-datepicker";
import './consumption.css';
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";


import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';
import { clickColor, inArray } from './../../../library/util';



import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import objAdvancedFilter from '../../../library/advancedFilterLibFn';
import axiosIntance from '../../../helper/axios';

import { checkAccess, FEATURES } from '../../../library/auth'

const SKUS = [
  "FL","FUELSAVE","USB","C-TYPE-CABLE","LGHTNG-CBL","WCHAR","BATTY","CAMLITE","SDCARD",
  "CAMEXTENDER","CAMWALLADAPTER","MICE","MICEEU","POWERSAVE","POWERSAVEUK","POWERSAVEEU",
  "BONE","WIFIB-2.4G","WIFI-USB","HEAT-V2","DOOR","HEATEUV2","HEATUKV2","PROPURE","PROPURE-FTR",
  "GLOSKETCH","CARSAFETY","CARTOYBLUE","CARTOYPINK","POSPRO","AGPUR","BUGZ","CITR","BUGGWATCH",
  "KNEESLEEVESM","KNEESLEEVELXL","HAIRCURLER","LASERREMOVER","PETBRUSH","DBFM","SHAVE","LRGSPKR",
  "NOBARK","OXIMETER","FUNGUSLASER","PHOTOSTICK","EBLB","NDP","CARVAC","NECK","SADL","EZBZ",
  "EZBZ-FIL","SNORE","PIK","TEETH","KIDZTEETH","MOUTH","VEGGIECLEAN","PLANT","SCREEN",
  "WHITENOISE","POPPCHOPP","BKBOARD","GROUT","AIR","AIR-L","DIFF-W","DIFF-B","DIFF-OIL",
  "SUNSET","BOOB-SM","BOOB-XL","NTGLS","GLASJUIC","TCGL","COOLWRISTS","BIKEDOCK","TEAMASK",
  "IPLPROV2","SPK","KNIFE","BLKSMARTWATCH","NAVYSMARTBAND","PINKSMARTBAND","WHITESMARTBAND",
  "BLKFITNESSWATCH","NAVYFITNESSBAND","PINKFITNESSBAND","WHITEFITNESSBAND","ORANGEFITNESSBAND",
  "REDFITNESSBAND","SLEEPPATCH","WCHARSINGLE","SMARTWATCHSCREEN","ABSTIMULATOR","GELPACK",
  "AIRBUDS","GRAYHAIR","HAIRCONDITIONER","BRUNETTEHAIR","CRYSTALHAIR","CARLOCK","CAMPLAMP",
  "CAMPWATCH","STICKERS","FLYBALL","CARVACFIL","MULTITOOLPEN","BEACON","HEATGLOW","DRONE",
  "DRONEFIL","DRONEBLADE","HEADLAMP","ACTIONCAM","DASHCAM","BOUNCYGREEN","BOUNCYBLUE",
  "SPINBRUSH","HEATGLOWEU","HEATGLOWUK","GESTURECAR","LUMB","SOCCERBALL","BRUSHPAD","BRUSHCONE",
  "BRUSHFLAT","KIDSCAMERA","LEDDISC","MICEUK", "CARHOLD", "SHOWERHEAD", "FLHIGHPOWER",
  "COPPERSOCK-S", "COPPERSOCK-M", "COPPERSOCK-L",
  "LEDGUASHA", "CHAINTRIM", "CHAINTRIMFLT", "CHAINTRIMCHAIN", "VITASERUM", "MOISTCREAM", 
  "MICROCURRENT", "NECKLACEGOLD", "NECKLACESILVER", "CARCLOTH", "FACELIFTING", 
  "SCALPMASSAGE", "SKINWAND", "ROUNDBUDS", "HIKINGSTAFF", "MINICAM",
  "DOGCOLLAR", "BREATHALYZER", "SAFETYBLANKET", "SURVIVALBAG",
  "RANGEHOOD", "RANGEOILFLT", "RANGEAIRFLT", "BGLAMP", "BGLAMPCITR",
  "BGFORCE", "BGFORCECITR", "PWRWASH", "PWRWASHFLT", "AGION",
  "BBQFORK", "FLEXVISION", "IONWATER", "HIKINGEXTRA",
  "TOILETCLEAN", "SPRAYBOTTLE", "ALLPURPOSETABS",
  "SWIVELTAB", "BBQTHERM", "FLOSSER", "NECKFAN",
  "USBSTAND", "WHITENOISEV2", "CARWAX",
  "PETJET", "PETGLOVE", "PETCARPET", "PETLICK", "RELIEFBELT-M", "RELIEFBELT-L", "CARCHARGER",
  "NOZZLE", "VEST-XS", "VEST-S", "VEST-M", "VEST-L", "VEST-XL",
  "VEST-XXL", "10KFLT", "WARMERHAND",
  "WARMERFOOT-S", "WARMERFOOT-M", "WARMERFOOT-L",
  "GALAXYCUBE", "TOYCRAB", 
  // "KIZUSHOEWHT-6", "KIZUSHOEWHT-7", "KIZUSHOEWHT-75", "KIZUSHOEWHT-8",
  // "KIZUSHOEWHT-9", "KIZUSHOEWHT-10", "KIZUSHOEWHT-11",
  'CYBERHEAT', 'LIGHTBAR', 'GAMESTICK',  'GAMECASE', 'KARAOKESPK', 'DREAMPEN',
  'DREAMSTRING', 'PICKLERACKET', 'PICKLECASE', 'PICKLEBALLS',
  'RING-7', 'RING-8', 'RING-9', 'RING-10', 'RING-11', 'RINGCASE',
  'KIZUSHOEWHT-37', 'KIZUSHOEWHT-38', 'KIZUSHOEWHT-39', 'KIZUSHOEWHT-40', 
  'KIZUSHOEWHT-41', 'KIZUSHOEWHT-42', 'KIZUSHOEWHT-43', 'KIZUSHOEWHT-44', 
  'KIZUSHOEWHT-45', 'KIZUSHOEWHT-46', 'KIZUSHOEWHT-LACES', 
  'KIZUSHOEBLK-37', 'KIZUSHOEBLK-38', 'KIZUSHOEBLK-39', 'KIZUSHOEBLK-40', 
  'KIZUSHOEBLK-41', 'KIZUSHOEBLK-42', 'KIZUSHOEBLK-43', 'KIZUSHOEBLK-44', 
  'KIZUSHOEBLK-45', 'KIZUSHOEBLK-46', 'KIZUSHOEBLK-LACES', 
  'RIVALSHOEWHT-37', 'RIVALSHOEWHT-38', 'RIVALSHOEWHT-39', 'RIVALSHOEWHT-40', 
  'RIVALSHOEWHT-41', 'RIVALSHOEWHT-42', 'RIVALSHOEWHT-43', 'RIVALSHOEWHT-44', 
  'RIVALSHOEWHT-45', 'RIVALSHOEWHT-46', 'RIVALSHOEWHT-LACES', 
  'RIVALSHOEBLK-37', 'RIVALSHOEBLK-38', 'RIVALSHOEBLK-39', 'RIVALSHOEBLK-40', 
  'RIVALSHOEBLK-41', 'RIVALSHOEBLK-42', 'RIVALSHOEBLK-43', 'RIVALSHOEBLK-44', 
  'RIVALSHOEBLK-45', 'RIVALSHOEBLK-46', 'RIVALSHOEBLK-LACES',
  'BLASTFAN', 'USBTRAVEL', 'AIRV2', 'TIREPLUG', 'SAUCERTOY', 'GLOWSTRING', 
  'LEAKDETECT', 'SCALPHEAD', 'SCALPSHAVE', 'GLXYLIGHT', 'GLOBELAMP', 'MOUTHTAPE', 
  'RANGESCOPE', 'BACKPACK', 'MAGFLT', 'TITANBOARD',
  'DESKBUDDY', 'DESKMARKERS', 'LENSCLEAN', 'LENSDRIVER', 'CYBERHEATUK',
  'WIPERSPRAY', 'BLASTER', 'BLASTERROUNDS', 'TOYROCKET', 'FLYSPIN', 'SMARTPLUG',
  'RING-6',
  'SCREWDRIVER',
  'SHEETSINGLE-GR', 'SHEETTWIN-GR', 'SHEETFULL-GR',  'SHEETQUEEN-GR', 'SHEETKING-GR', 
  'SHEETCAKING-GR', 'SHEETPILLOW-ST-GR', 'SHEETPILLOW-K-GR', 'SHEETCABLE', 
  'DESKMAT',
  'CANOPENER',
  'TRANSLATOR', 'CYBERWIFI',
  'NIGHTDASH', 'DETECTOR', 'BLUEGLASSES',
  'GLASSBRUSH', 'GLASSOIL', 'FUNGUSLIGHT', 'MIRRORCAM',
  'ACBREEZE', 'BGPRO', 'SKYCAM', 'SKYCAMFIL', 'SKYCAMBLADE', 'GELSEAT',
  'FORCEAIR', 'WAISTFAN', 'GUMCLEAN',
  'PETBALL', 'AIGLASSES', 'PUPPAD', 'EARCAM', 'WRISTBALL', 'SOSPAGER', 'SOSBUTTON',
  'AUTO-ADAPTER', 'RINGKIT', 'TAPFAUCET', 'TAPFILTER', 
  'FOOTMASSAGE', 'KNEEMASSAGE', 'SMARTCANE',
  'HEADREST', 'E-SCISSORS', 'EZCOOL', 'LEAFBLOW', 'WELDPRO', 'WELDSOLDER',
  'GRAVCAR', 'SPIDYGLOVE', 'TOYDUCK',
  'DINOEGG', 'MICMIX', 'PATROLCAM', 'STEAMBRUSH', 'VACMITES', 'VACMITESFLTR',
  'E-RAZOR', 'PIXICAM', 'BODYCAM', 'BUBBLE', 'THERMACUP', 'BPBAND',
  'ICESCRAPE', 'HEATGLOVE', 'SHOEDRY', 'CAMPLIGHT',  'SHWRFAUCET',
  'SHWRFILTER', 'HEATBLANKET', 'GPSTRACK', 'PETGPS', 'CARTRACK',
  'TICTACTOE', 'HEARAID', 'KEDMICRO', 'MINIMASSAGE', 'IRONMINI',
  'FISHGAME', 'EARPLUG-BLK', 'EARPLUG-WHT', 'EARPLUG-BUDS', 'LANYARD',
  'LIGHTSPK', 'MINIMOP', 'MOPREFILL', 'LEAFBLOWFLT', 'MAGICLOTH', 'BINGO',
  'BODYSHAPER', 'NEBULIZER', 'CARSPRAY', 'RETROPLAY', 'CLARILENS', 'MICROCAM',
  'GRIPTRAIN', 'BGCB',
  'DRYRACK', 'DUFFBAG', 'EZHANG',
]

const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: 'white'
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    background: isFocused
      ? 'lightblue'
      : isSelected
        ? '#2a7bc0'
        : undefined,
    zIndex: 1
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
}
const style_advanced = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



const AddIconClasses = { color: '#337ab7', fontSize: '30px', marginLeft: '128px', marginTop: "-15px", cursor: 'pointer' };

const styleCloseIcon = {
  margin: '-27px'
}



function Consumption() {
  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date().setHours(23, 59, 0, 0));

  const [sku, setSKU] = useState('');
  const [skuArray, setSKUArray] = useState([]);
  const [selectedrowList, setSelectedRowList] = useState([]);


  /************* Advanced Filter ***********/
  const [group, setgroup] = useState('');

  const [groupP, setgroupP] = useState('');

  const [groupT, setgroupT] = useState('');

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const selectInputRef = useRef();
  const selectInputRefInputFilter = useRef();
  const [filterLabel, setFilterLabel] = useState([])
  const [filterValue, setFilterValue] = useState('')
  const [filterArray, setFilterArray] = useState([]);

  const [filterValueT, setFilterValueT] = useState('')
  const [filterArrayT, setFilterArrayT] = useState([]);

  const [filterValueP, setFilterValueP] = useState('')
  const [filterArrayP, setFilterArrayP] = useState([]);
  const [selectLabelHeader, setSelectLabelHeader] = useState([]);
  const [selectLabelHeaderP, setSelectLabelHeaderP] = useState([]);


  const loadFilterLabel = (inputValue) => {
    let tempCategory = selectLabelHeader;
    return new Promise((resolve) => {
      resolve(tempCategory.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
    });
  }
  const loadFilterLabelP = (inputValue) => {
    let tempCategory = selectLabelHeaderP;
    return new Promise((resolve) => {
      resolve(tempCategory.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
    });
  }

  const handleChangeFilterP = (e) => {
    if (e.target.value != undefined) {
      setFilterValueP(e.target.value);
    }
  }

  const handleChangeFilterT = (e) => {
    if (e.target.value != undefined) {
      setFilterValueT(e.target.value);
    }
  }


  const addFilterT = () => {
    if (groupT != '' && filterValueT != '') {
      let tempObj = { field: groupT, value: filterValueT };
      filterArrayT.push(tempObj);
      setFilterArrayT(filterArrayT);
      setFilterValueT('')
    }
  }

  const addFilterP = () => {
    if (groupP != '' && filterValueP != '') {
      let tempObj = { field: groupP, value: filterValueP };
      filterArrayP.push(tempObj);
      setFilterArrayP(filterArrayP);
      setFilterValueP('')
    }
  }

  const deleteAdvancedFilterPFn = (item, index) => {
    const arr = filterArrayP.filter((item, j) => j != index);
    console.log(arr)
    setFilterArrayP(arr);
  }

  const deleteAdvancedFilterTFn = (item, index) => {
    const arr = filterArrayT.filter((item, j) => j != index);
    console.log(arr)
    setFilterArrayT(arr);
  }
  const handleChangeT = (target) => {
    if (target != undefined) {
      setgroupT(target.value);
    }
  }

  const handleChangeP = (target) => {
    if (target != undefined) {
      setgroupP(target.value);
    }
  }



  checkUserTypeFn(history);

  function checkUserTypeFn(history) {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const usertype = userdata.type;
    console.log('in check usertype fn');
    console.log(usertype)
    if (!checkAccess(FEATURES.consumption_report)) {
      history.push('/');
    }
}

  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const setRowBackground = (selectedRow) => {
    console.log('hey');
    console.log('38 ====')
    console.log(selectedRow)
    let tempObj = {};
    console.log(selectedRow.tableData.id)
    console.log(selectedrowList)
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      console.log('here')
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      console.log('here not')
      setSelectedRow(5000)
      //setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
      removeItemOnce(selectedrowList, selectedRow.tableData.id);

    }
    console.log('52 line')
    console.log(selectedrowList)


  }

  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }

  const [reportData, setReportData] = useState([])
  const [loader, setLoader] = useState(false)

  const [showSkuDetails, setShowSkuDetails] = useState(false);
  const [skuDetails, setSkuDetails] = useState({sku: '', fulfillment: '', details: []});

  const handleShowSkuDetails = (sku, fulfillment) => {
    if (reportData) {
      const row = reportData.find(r => r.Fulfillment === fulfillment);
      if (row && row[sku]) {
        setSkuDetails({
          sku: sku,
          fulfillment: fulfillment,
          details: Object.keys(row.group_category[sku]).map(grp => {
            return {
              group_category: grp,
              consumption: row.group_category[sku][grp]
            }
          }).sort((a, b) => b.consumption - a.consumption)
        });
        setShowSkuDetails(true);
      }
    }
  };

  const handleCloseSkuDetails = () => {
    setShowSkuDetails(false);
    setSkuDetails({sku:'', fulfillment: '', details: []});
  };

  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg, setSuccessMsg] = useState('')
  useEffect(() => {
    setSelectLabelHeader(objAdvancedFilter.getFilterColumns('transactions'))
    setSelectLabelHeaderP(objAdvancedFilter.getFilterColumns('products'))
    return () => {
      console.log('un subscribe')
    }



  }, [])

  const ResetFilter = () => {
    setMessage('')
    setEndDate(new Date(Date.now()))
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  }

  const fetchApi = () => {

    let filterStringP = '';
    filterArrayP.forEach((i, j) => {
      console.log(i)
      filterStringP += `P.${i.field}=${i.value}*`
    })

    let filterStringT = '';
    filterArrayT.forEach((i, j) => {
      console.log(i)
      filterStringT += `T.${i.field}=${i.value}*`
    })


    if (startDate == null) {
      setMessage('Date must not be blank')
      return false;
    } else {
      setMessage('')
    }
    setLoader(true)
    let SKUStr = skuArray.join('*');
    console.log(SKUStr);


    axiosIntance.get(baseUrl + '/reports/salesperformance/consumption?startdate=' + moment(startDate).format('YYYY-MM-DD HH:mm:ss') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm:ss') + "&sku=" + SKUStr + "&filterStringP=" + filterStringP + "&filterStringT=" + filterStringT, {}).then(response => {


      if (response.data.result.length > 0) {
        response.data.result.forEach(row => {
          SKUS.forEach(sku => {
            if (row[sku] === undefined) {
              row[sku] = 0;
              row.group_category[sku] = '';
            }
          });
        });
        console.log('data we have')
        response.data.result.forEach((i, j) => {
          console.log(i);
        });
        setReportData(response.data.result);
        setLoader(false)
      } else {
        setLoader(false)
        setReportData([]);
      }

    }).catch(error => {
      setLoader(false)
      setMessage('Something went wrong');
    });
  }

  const fetchApiDownload = () => {
    let filterStringP = '';
    filterArrayP.forEach((i, j) => {
      console.log(i)
      filterStringP += `P.${i.field}=${i.value}*`
    })

    let filterStringT = '';
    filterArrayT.forEach((i, j) => {
      console.log(i)
      filterStringT += `T.${i.field}=${i.value}*`
    })
    let SKUStr = skuArray.join('*');
    console.log(SKUStr);
    const token = window.localStorage.getItem('token');
    window.location.href = baseUrl + '/reports/salesperformance/consumption/download?startdate=' + moment(startDate).format('YYYY-MM-DD HH:mm:ss') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm:ss') + "&sku=" + SKUStr + "&filterStringP=" + filterStringP + "&filterStringT=" + filterStringT+"&token="+token;
  }
  const FilterSet = () => {
    if (sku != '') {
      if (inArrayForString(sku, skuArray) == false) {
        setSKUArray(oldArray => [...oldArray, sku]);
        setSKU('');
      }
    }
  }

  const deleteSKUFn = (item, index) => {
    removeItemOnce(skuArray, item);
    let temp = skuArray.filter((category) => category !== item);
    setSKUArray(temp);
  }


  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }


  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />



      <div></div>
      <div></div>
      <div></div>
      <div></div>

      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>




      <Modal
        open={showSkuDetails}
        onClose={handleCloseSkuDetails}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">

        <Box sx={{
          ...style_advanced,
          padding: '0px'
        }}>

          <MaterialTable
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            style={{width: '700px', padding: '20px 15px 15px 15px'}}
            columns={[
              { title: "Group Category", field: "group_category" },
              { title: "Consumption", field: "consumption" },
            ]}
            data={skuDetails.details}
            title={`${skuDetails.sku} | ${skuDetails.fulfillment}` }
            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize: 10,
              loadingType: 'linear',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              }),
            }} />

            <div style={{
              position: 'absolute',
              top: '5px',
              right: '5px'
            }}>
              <CloseIcon className='closeIcon' onClick={handleCloseSkuDetails} />
            </div>

        </Box>

      </Modal>


      <section id="content-wrapper">

        <div classname="advancedFilterSection">
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style_advanced}>


              <label>Transaction Header</label>
              <label className='filterValueStyle'>Filter Values</label>
              <div class="input-bar">

                <div className="input-bar-item width100">

                  <AsyncSelect
                    ref={selectInputRef}
                    components={animatedComponents}
                    onChange={e => handleChangeT(e)}
                    cacheOptions
                    defaultOptions
                    maxMenuHeight={250}
                    className="widthSelectInput"
                    classNamePrefix="select"
                    styles={colourStyles}
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    loadOptions={loadFilterLabel}
                  />
                </div>

                <>

                  &nbsp;&nbsp;&nbsp;
                  <div className="input-bar-item width100">
                    <input type='text'
                      ref={selectInputRefInputFilter}
                      className='width140x filterValue'
                      placeholder="Value"
                      onChange={e => handleChangeFilterT(e)}
                    />
                    <AddIcon style={AddIconClasses} onClick={addFilterT} />
                  </div>
                </>


                <div className="input-bar-item width100">
                  <div className="input-bar-item closeModel closeIconCommon">
                    <CloseIcon className='closeIcon' onClick={handleClose} />
                  </div>
                </div>

              </div>

              <label>Products Header</label>
              <label className='filterValueStyle'>Filter Values</label>
              <div class="input-bar">

                <div className="input-bar-item width100">

                  <AsyncSelect
                    ref={selectInputRef}
                    components={animatedComponents}
                    onChange={e => handleChangeP(e)}
                    cacheOptions
                    defaultOptions
                    maxMenuHeight={250}
                    className="widthSelectInput"
                    classNamePrefix="select"
                    styles={colourStyles}
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    loadOptions={loadFilterLabelP}
                  />
                </div>

                <>

                  &nbsp;&nbsp;&nbsp;
                  <div className="input-bar-item width100">
                    <input type='text'
                      ref={selectInputRefInputFilter}
                      className='width140x filterValue'
                      placeholder="Value"
                      onChange={e => handleChangeFilterP(e)}
                    />
                    <AddIcon style={AddIconClasses} onClick={addFilterP} />
                  </div>
                </>


                {/* <div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div> */}

              </div>

              <div className="input-bar-item width100">
                <div className="FilterSection">

                  {filterArrayT.map((item, index) => (
                    <>
                      <span className='filterCategory' id={index}>
                        <span className="filterSpan">{item.field} = {item.value}</span>
                        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item, index)} className='closeIcon' />
                      </span>
                      <span className="whitespaceSpan">{'            '}</span>
                    </>
                  ))}

                  {filterArrayP.map((item, index) => (
                    <>
                      <span className='filterCategory' id={index}>
                        <span className="filterSpan">{item.field} = {item.value}</span>
                        <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item, index)} className='closeIcon' />
                      </span>
                      <span className="whitespaceSpan">{'            '}</span>
                    </>
                  ))}
                </div>

              </div>




            </Box>
          </Modal>
        </div>


        <label>Date for Report</label>
        <div class="input-bar">
          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={startDate}
              className='width140x'
              onChange={(date) => setStartDate(date)}
              placeholder='Start Date'
              // showTimeInput

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}


            />



          </div>

          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={endDate}
              className='width140x'
              onChange={(date) => setEndDate(date)}
              placeholder='End Date'
              showTimeSelect
              timeFormat="p"
              timeIntervals={15}
            />

          </div>
          &nbsp;&nbsp;&nbsp;

          &nbsp;&nbsp;&nbsp;

          {/* <div className="input-bar-item width100">
    
    <input 
    type="text" 
     name='sku'
     className='width140x'
     value={sku}
     placeholder="SKU"
     onChange={e => setSKU(e.target.value)} 
    />
      
    </div> */}

          {/* <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div> */}

          <div className="input-bar-item">
            <button type="button" onClick={handleOpen} className="btn btn-primary">Advanced Filter</button>

          </div>
          <div class="input-bar-item">
            <button type="button" onClick={fetchApi} className="btn btn-primary">Run Report</button>

          </div>
          <div class='input-bar-item'>
            <button type="button" onClick={ResetFilter} className="btn btn-primary">Reset</button>
          </div>



          <div className='downloadReportBtn'>
            {

              <button type="button" onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>

            }

          </div>
        </div>

        {/* <div className="FilterSection">
  
  {skuArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">SKU = {item}{ }</span>
       <span  onClick={(event) => deleteSKUFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}






    
  </div> */}

        <div className="input-bar-item width100">
          <div className="FilterSection">

            {filterArrayT.map((item, index) => (
              <>
                <span className='filterCategory' id={index}>
                  <span className="filterSpan">{item.field} = {item.value}</span>
                  <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item, index)} className='closeIcon' />
                </span>
                <span className="whitespaceSpan">{'            '}</span>
              </>
            ))}

            {filterArrayP.map((item, index) => (
              <>
                <span className='filterCategory' id={index}>
                  <span className="filterSpan">{item.field} = {item.value}</span>
                  <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item, index)} className='closeIcon' />
                </span>
                <span className="whitespaceSpan">{'            '}</span>
              </>
            ))}
          </div>

        </div>

        {loader ?
          <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> :

          //setSelectedRow(selectedRow.tableData.id)
          <MaterialTable
            // onRowClick={((evt, selectedRow) =>
            //   setRowBackground(selectedRow)
            // )}

            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            columns={[
              { title: " ", field: "Fulfillment", cellStyle: { fontWeight: 'bold' } },
              ...SKUS.map(sku => { 
                return { 
                  title: sku,
                  field: sku,
                  render: (rowData) => (
                    rowData[sku]
                      ? <button className="link-button"
                          onClick={() => handleShowSkuDetails(sku, rowData.Fulfillment)}
                        >{ rowData[sku] }</button>
                      : rowData[sku]
                  ),
                } 
              })
            ]}
            data={
              reportData
            }
            title="Consumption Report"

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize: 10,
              loadingType: 'linear',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              }),
              // fixedColumns: {
              //   left: 1,
              //   right: 0
              // }
            }}

          />
        }
      </section>

    </div>

  )
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
    if (haystack[i].toLowerCase() == needle.toLowerCase())
      return true;
  }
  return false;
}

function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

export default Consumption
